<section class="panel">
  @if (businesses.length > 0) {

    <div class="business-card-grid">
      @for (b of businesses; track b.businessId) {
        <article
          class="business-card"
          [class.active]="selectedBusiness?.businessId === b.businessId"
          (click)="onSelectBusiness(b)">

          <header class="business-card-header">
            <div class="business-title-row">
              <h4>{{ b.name }}</h4>
              @if (b.flagUrl) {
                <img
                  [src]="b.flagUrl"
                  [alt]="b.countryName"
                  class="business-flag" />
              }
            </div>
          </header>

          <div class="business-body">
            <div class="business-address" *ngIf="b.address">
              {{ b.address }}
            </div>
            
            <div class="business-location">
              {{ b.city }}<span *ngIf="b.city && b.countryName">, </span>{{ b.countryName }}
            </div>
            <div class="business-phone" *ngIf="b.officePhone">
              {{ b.officePhone }}
            </div>
          </div>

          <footer class="business-footer">
            <span class="tag" [class.tag-active]="b.isActive" [class.tag-inactive]="!b.isActive">
              {{ b.isActive ? 'Active' : 'Inactive' }}
            </span>

            <span class="tag" *ngIf="b.hasTax">
              Tax {{ b.taxRate }}%
            </span>

            <span class="tag" *ngIf="b.currencySymbol">
              {{ b.currencySymbol }}
            </span>
          </footer>

        </article>
      }
    </div>

    @if (selectedBusiness) {
      <div class="business-details">
        <h4>Selected business: {{ selectedBusiness.name }}</h4>
        <!-- e.g. business-specific roles/permissions component -->
        <!-- <app-user-business-detail [business]="selectedBusiness"></app-user-business-detail> -->
      </div>
    }

  } @else {
    <span class="no-roles">No businesses assigned to this user.</span>
  }

</section>
